import { TPAComponentProps } from '../../types';
import { TabItem } from './Tab/types';

export * from './Tab/types';
export * from './ScrollableTabs/types';
export * from './TabsNavButton/types';

export enum TabsSkin {
  fullUnderline = 'fullUnderline',
  clear = 'clear',
  fitUnderline = 'fitUnderline',
}

export enum TabsAlignment {
  center = 'center',
  left = 'left',
  right = 'right',
}

export enum TabsVariant {
  fullWidth = 'fullWidth',
  fit = 'fit',
}

export enum TabsNavButtonOptions {
  both = 'both',
  left = 'left',
  right = 'right',
  none = 'none',
}

export enum OverflowBehavior {
  scroll = 'scroll',
  wrap = 'wrap',
}

export interface TabsProps extends TPAComponentProps {
  /** tabs to be displayed */
  items: TabItem[];
  /** callback function when tab is selected , returning the selected item index and the  click event */
  onTabClick?(index: number, e: React.BaseSyntheticEvent): void;
  /** index of the selected tab item */
  activeTabIndex?: number;
  /** control whether to display border under tabs*/
  skin?: TabsSkin;
  /** control where to align the tabs */
  alignment?: TabsAlignment;
  /** control overflow behavior */
  overflowBehavior?: OverflowBehavior;
  /** control whether to set tabs on all content width*/
  variant?: TabsVariant;
  'data-hook'?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  'aria-describedby'?: string;
  /**
   * Tabs component supports 2 modes:
   * isTablist=false (default) adds "navigation" role and renders tabs as a list of links;
   * isTablist=true adds "tablist" role and applies a few other attributes as described in Tabs a11y pattern;
   */
  isTablist?: boolean;
  onKeyDown?(e: React.KeyboardEvent): void;
}

export interface TabsState {
  navButtons?: TabsNavButtonOptions;
  animateIndicator: boolean;
  selectedTab: number;
}
